import log, { LogLevelNames } from 'loglevel';
import { reg, apply } from 'loglevel-plugin-prefix';

reg(log);

type FormatterTemplate = 'default';
const templates = {
  default: (level: string, name?: string, timestamp?: Date) =>
    `[${timestamp}] ${level} (${name}):`,
};

// Creates a named logger that we configure here and that can be reused anywhere:
export function getLogger(
  name: string,
  level: LogLevelNames = 'info',
  template: FormatterTemplate = 'default'
) {
  const logger = log.getLogger(name);
  const formatter = templates[template];
  logger.setLevel(level);
  apply(logger, { format: formatter });

  return logger;
}
